import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "greetings" }
const _hoisted_2 = { class: "version-text" }


import VersionDisplay from "./VersionDisplay.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderText',
  props: {
    msg: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(VersionDisplay, { displayMode: "text" })
    ])
  ]))
}
}

})